// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2wT44","requiredAsterisk":"Info_requiredAsterisk__uvgPB"};